
const initial = {
	todos:[
		{ id: 1, item: 'case 1' },
		{ id: 2, item: 'case 2' }]
};
const jestTest = (state = initial) => {
	return state;
};

export default jestTest;